import React from 'react';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { ParsedRecord } from '../types';

interface DataPreviewProps {
  records: ParsedRecord[];
}

export const DataPreview: React.FC<DataPreviewProps> = ({ records }) => {
  const getRecordTone = (recordId: string): 'success' | 'warning' | 'error' | 'info' | 'neutral' => {
    switch (recordId) {
      case 'HDR': return 'info';
      case 'TRLR': return 'success';
      case 'DTL': return 'info';
      case 'CLM': return 'neutral';
      case 'STC': return 'warning';
      default: return 'neutral';
    }
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #e0e0e0' }}>Line</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #e0e0e0' }}>Record Type</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #e0e0e0' }}>Key Fields</th>
          </tr>
        </thead>
        <tbody>
          {records.map((r, i) => (
            <tr key={i}>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{r.line}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}><Badge variant={getRecordTone(r.recordType)}>{r.recordType}</Badge></td>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                {r.fields && Object.keys(r.fields).length > 0
                  ? Object.entries(r.fields).map(([k, v], idx) => (
                      <span key={idx} style={{ display: 'inline-block', marginRight: 8, padding: '4px 8px', background: '#f5f7fa', borderRadius: 6, fontFamily: 'monospace', wordBreak: 'break-all' }}>
                        {k}: {String(v)}
                      </span>
                    ))
                  : <span style={{ fontFamily: 'monospace', color: '#999', wordBreak: 'break-all' }}>{r.rawData || ''}</span>
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
